const reportHubPage = require("./reportHub-page");
const reportHubFullcont = require("./reportHub-fullcont");

export function start(detail) {
  obj[detail.elem].start(detail);
}

const obj = {
  page: {
    start: (detail) => {
      reportHubPage.start(detail);
    },
  },
  fullcont: {
    start: (detail) => {
      reportHubFullcont.start(detail);
    },
  },
};
